import React, { Component } from 'react'
import Switch from 'react-switch'

import { FillerInlineDiv } from '../StyledComponents/Fillers'
import { SettingsTitle, SettingsRow, InfoButton, InfoButtonWrapper } from '../StyledComponents/Settings'

class SettingsRowSwitch extends Component {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(checked) {
        this.props.handleChange(checked)
    }

    render() {
        const {
            title,
            columns,
            isFirst,
            checked,
            showInfoModal,
            disabled,
        } = this.props

        const infoModal = showInfoModal ? (
            <InfoButtonWrapper>
                <InfoButton onClick={showInfoModal}>?</InfoButton>
            </InfoButtonWrapper>
        ) : null

        return (
            <SettingsRow isFirst={isFirst} columns={columns}>
                <SettingsTitle className="align-top col-8" disabled={disabled}>
                    {title}{infoModal}
                </SettingsTitle>
                <FillerInlineDiv className="col-4 text-right">
                    <Switch
                        disabled={disabled}
                        className="text-left"
                        onChange={this.handleChange}
                        checked={checked}
                        uncheckedIcon={null}
                        checkedIcon={null}
                        onColor="#4cd964"
                        offColor="#fff"
                        offHandleColor="#ccc"
                        height={30}
                    />
                </FillerInlineDiv>
            </SettingsRow>
        )
    }
}

SettingsRowSwitch.defaultProps = {
    isFirst: false,
    checked: false,
    title: '',
}

export default SettingsRowSwitch



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsRowSwitch.js